/*
    Consent Mode v2 - Polywood UK (luxuryrecycledgardenfurniture.co.uk)
    
    Overview: Consent mode parameters

    Setting Name            Used by Google    Description
    ad_storage              Yes               Enables storage (such as cookies) related to advertising
    analytics_storage       Yes               Enables storage (such as cookies) related to analytics e.g. visit duration
    ad_user_data            Yes               Whether Google's services can use user data for building advertising audiences
    ad_personalization      Yes               Whether Google's services can use the data for remarketing
    functionality_storage   No                Enables storage that supports the functionality of the website or app e.g. language settings
    personalization_storage No                Enables storage related to personalization e.g. video recommendations
    security_storage        No                Enables storage related to security such as authentication functionality, fraud prevention, and other user protection
*/

const defaultConsent = {
  functionality_storage: "denied",
  security_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  personalization_storage: "denied",
  wait_for_update: 500,
};

function setConsentCookie(value) {
  const encoded = encodeURIComponent(JSON.stringify(value));
  document.cookie = `consentMode=${encoded}; max-age=${60 * 60 * 24 * 365}; path=/; domain=.luxuryrecycledgardenfurniture.co.uk; SameSite=Lax`;
}

function getConsentCookie() {
  const match = document.cookie.match(/(?:^|; )consentMode=([^;]*)/);
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

gtag("consent", "default", defaultConsent);

const consentSettings = getConsentCookie() || localStorage.getItem("consentMode");
const consentMode = consentSettings
  ? (typeof consentSettings === "string" ? JSON.parse(consentSettings) : consentSettings)
  : defaultConsent;
if (consentSettings && !localStorage.getItem("consentMode")) {
  localStorage.setItem("consentMode", JSON.stringify(consentMode));
}
gtag("consent", "update", consentMode);

window.onload = function () {
  const cookie_consent_banner_dom = `
    <div id="cookie-consent-backdrop"></div>
    <div id="cookie-consent-banner" class="cookie-consent-banner">
        <h3>This website uses cookies</h3>
        <p>We use cookies to enhance your browsing experience, analyse site traffic, and serve tailored advertisements. By clicking 'Accept All' you consent to the use of cookies. You can change your cookie preferences at any time. By using our website, you agree to the collection of data as described in our <a href="/policies/privacy-policy">Privacy Policy</a>.</p>
        <div class="cookie-consent-options">
          <label><input id="consent-necessary" type="checkbox" value="Necessary" checked disabled>Necessary</label>
          <label><input id="consent-analytics" type="checkbox" value="Analytics" checked>Analytics</label>
          <label><input id="consent-marketing" type="checkbox" value="Marketing" checked>Targeting &amp; Advertising</label>
        </div>
        <div class="cookie-consent-buttons">
          <button id="cookie-consent-btn-reject-all" class="cookie-consent-button btn-grayscale">Reject All</button>
          <button id="cookie-consent-btn-accept-some" class="cookie-consent-button btn-outline">Accept Selection</button>
          <button id="cookie-consent-btn-accept-all" class="cookie-consent-button btn-success">Accept All</button>
        </div>
        <div>
          <button id="more-detail-btn">More Detail</button>
        </div>
    </div>
  `;

  const cookie_details_overlay_dom = `
    <div id="cookie-management-overlay">
      <div class="overlay-content">
        <h2>Manage Cookies</h2>
        <div class="cookie-type">
          <label>
            <input type="checkbox" id="consent-necessary-overlay" value="Necessary" checked disabled>
            Necessary Cookies
          </label>
          <p>Essential for the site and any requested services to work, but do not perform any additional or secondary function.</p>
        </div>
        <div class="cookie-type">
          <label>
            <input type="checkbox" id="consent-analytics-overlay">
            Analytics Cookies
          </label>
          <p>Provide statistical information on site usage, e.g., web analytics so we can improve this website over time.</p>
        </div>
        <div class="cookie-type">
          <label>
            <input type="checkbox" id="consent-marketing-overlay">
            Targeting &amp; Advertising Cookies
          </label>
          <p>Used to create profiles or personalise content to enhance your shopping experience. These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant and personalised adverts on other sites. If you do not allow these cookies, you will experience less targeted advertising.</p>
        </div>
        <button id="close-overlay">Close</button>
        <button id="save-cookie-preferences">Save Preferences</button>
      </div>
    </div>`;

  const cookie_consent_button_dom = `
    <button id="cookie-consent-button" aria-label="Cookie preferences">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.6 11.1a1 1 0 0 0-.9-.5h-.3a2.5 2.5 0 0 1-2.4-2.4v-.3a1 1 0 0 0-.5-.9 1 1 0 0 0-1 0 2.5 2.5 0 0 1-3.4-1 2.5 2.5 0 0 1 0-2.4 1 1 0 0 0 0-1 1 1 0 0 0-.9-.5A10 10 0 1 0 22 12a1 1 0 0 0-.4-.9zM7 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2-5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>
    </button>
  `;

  document.body.insertAdjacentHTML("beforeend", cookie_consent_banner_dom);
  const cookie_consent_backdrop = document.getElementById("cookie-consent-backdrop");
  const cookie_consent_banner = document.getElementById("cookie-consent-banner");

  document.body.insertAdjacentHTML("beforeend", cookie_details_overlay_dom);
  const cookie_consent_overlay = document.body.lastElementChild;

  document.body.insertAdjacentHTML("beforeend", cookie_consent_button_dom);
  const cookie_consent_button = document.getElementById("cookie-consent-button");
  cookie_consent_button.addEventListener("click", () => {
    showBanner();
  });

  function dnt() {
    return navigator.doNotTrack == "1" || window.doNotTrack == "1";
  }

  function gpc() {
    return navigator.globalPrivacyControl || window.globalPrivacyControl;
  }

  function showBanner() {
    const cm = JSON.parse(window.localStorage.getItem("consentMode"));
    if (cm && cm.functionality_storage) {
      if (cm.functionality_storage == "granted") {
        document.querySelector("#consent-necessary").checked = true;
        document.querySelector("#consent-necessary").disabled = true;
      } else {
        document.querySelector("#consent-necessary").checked = false;
        document.querySelector("#consent-necessary").disabled = false;
      }
      document.querySelector("#consent-analytics").checked =
        cm.analytics_storage == "granted" ? true : false;
      document.querySelector("#consent-marketing").checked =
        cm.ad_storage == "granted" ? true : false;
    }
    cookie_consent_backdrop.style.display = "block";
    cookie_consent_banner.style.display = "flex";
    document.body.classList.add("cookie-consent-active");
  }

  function showOverlay() {
    hideBanner();
    const cm = JSON.parse(window.localStorage.getItem("consentMode"));
    if (cm && cm.functionality_storage) {
      if (cm.functionality_storage == "granted") {
        document.querySelector("#consent-necessary-overlay").checked = true;
        document.querySelector("#consent-necessary-overlay").disabled = true;
      } else {
        document.querySelector("#consent-necessary-overlay").checked = false;
        document.querySelector("#consent-necessary-overlay").disabled = false;
      }
      document.querySelector("#consent-analytics-overlay").checked =
        cm.analytics_storage == "granted" ? true : false;
      document.querySelector("#consent-marketing-overlay").checked =
        cm.ad_storage == "granted" ? true : false;
    }
    cookie_consent_overlay.style.display = "flex";
  }

  function hideOverlay() {
    cookie_consent_overlay.style.display = "none";
    document.body.classList.remove("cookie-consent-active");
  }

  function hideBanner() {
    cookie_consent_backdrop.style.display = "none";
    cookie_consent_banner.style.display = "none";
    document.body.classList.remove("cookie-consent-active");
  }

  window.cookieconsent = {
    show: showBanner,
    hide: hideBanner,
    showInfo: showOverlay,
    hideInfo: hideOverlay,
  };

  function setConsent(consent) {
    const consentMode = {
      ad_storage: consent.marketing && !dnt() ? "granted" : "denied",
      analytics_storage: consent.analytics && !dnt() ? "granted" : "denied",
      ad_user_data: consent.marketing && !dnt() ? "granted" : "denied",
      ad_personalization: consent.marketing && !gpc() ? "granted" : "denied",
      functionality_storage: consent.necessary ? "granted" : "denied",
      security_storage: consent.necessary ? "granted" : "denied",
    };
    window.cookieconsent.consentMode = consentMode;

    // Google Consent Mode v2
    gtag("consent", "update", consentMode);

    // Shopify Customer Privacy API
    // Maps our consent categories to Shopify's expected signals:
    //   marketing  → ad_storage, ad_user_data, ad_personalization
    //   analytics  → analytics_storage
    //   preferences → functionality_storage, personalization_storage
    // Shopify persists this into checkout via its own HTTP-only cookies,
    // so consent carries through even though our banner doesn't load on checkout.
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            marketing: consent.marketing && !dnt() ? true : false,
            analytics: consent.analytics && !dnt() ? true : false,
            preferences: consent.necessary ? true : false,
          },
          function () {}
        );
      } catch (e) {
        console.warn("Shopify Customer Privacy API error:", e);
      }
    }

    localStorage.setItem("consentMode", JSON.stringify(consentMode));
    setConsentCookie(consentMode);
    dataLayer.push({ event: "consent_updated" });
  }

  if (cookie_consent_banner) {
    Array.from(document.querySelectorAll(".cookie-consent-banner-open")).map(
      (btn) => {
        btn.addEventListener("click", () => {
          showBanner();
        });
      }
    );

    if (getConsentCookie() || window.localStorage.getItem("consentMode")) {
      hideBanner();
    } else {
      showBanner();
    }

    cookie_consent_banner
      .querySelector("#cookie-consent-btn-accept-all")
      .addEventListener("click", () => {
        setConsent({
          necessary: true,
          analytics: true,
          preferences: true,
          marketing: true,
          partners: true,
        });
        hideBanner();
      });
    cookie_consent_banner
      .querySelector("#cookie-consent-btn-accept-some")
      .addEventListener("click", () => {
        setConsent({
          necessary: true,
          analytics: document.querySelector("#consent-analytics").checked,
          marketing: document.querySelector("#consent-marketing").checked,
        });
        hideBanner();
      });
    cookie_consent_banner
      .querySelector("#cookie-consent-btn-reject-all")
      .addEventListener("click", () => {
        setConsent({
          necessary: true,
          analytics: false,
          preferences: false,
          marketing: false,
          partners: false,
        });
        hideBanner();
      });
    cookie_consent_banner
      .querySelector("#more-detail-btn")
      .addEventListener("click", () => {
        showOverlay();
        hideBanner();
      });
    cookie_consent_overlay
      .querySelector("#save-cookie-preferences")
      .addEventListener("click", () => {
        setConsent({
          necessary: true,
          analytics: document.querySelector("#consent-analytics-overlay")
            .checked,
          marketing: document.querySelector("#consent-marketing-overlay")
            .checked,
        });
        hideBanner();
        hideOverlay();
      });
    cookie_consent_overlay
      .querySelector("#close-overlay")
      .addEventListener("click", () => {
        showBanner();
        hideOverlay();
      });
  }
};